import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { ToDateJalali, ToTime } from "../../../Common/Function";

function RandomBlogCardSidebar({ data }) {
  return (
    <Fragment>
      <Link to={`/Blogs/${data && data.slug}`}>
        <div
          className="border-dashed-blog d-flex flex-column flex-sm-row-reverse my-2 rounded-5 col-12"
          style={{ margin: "5px 10px", paddingBottom: "10px" }}
        >
          <div
            style={{ overflow: "hidden" }}
            className="d-flex col-sm-3 col-6 mx-auto"
          >
            <div className="d-flex align-items-center" style={{ flex: 1 }}>
              <img
                src={
                  Array.isArray(data.images)
                    ? data.images[0]
                    : window.origin + "/WebSide/assets/images/biabanian/G1.jpg"
                }
                alt={
                  data
                    ? data.seo && data.seo.seoKeyword && data.seo.seoKeyword
                    : "nikotan | نیکوتن"
                }
                style={{ height: "100px", borderRadius: "16px" }}
                className=" w-100 object-fit-cover img-fluid"
              />
            </div>
          </div>
          <div
            className="text px-2 d-flex flex-column justify-content-between"
            style={{
              flex: 4,
              display: "flex",
              flexDirection: "column",
              paddingRight: "5px",
            }}
          >
            <div className="d-flex justify-content-between">
              <h6
                style={{
                  fontWeight: "500",
                }}
              >
                {data && data.title.toString().length > 25
                  ? data.title.toString().substr(0, 30) + "..."
                  : data.title}
              </h6>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{}}
            >
              <div>
                <p
                  style={{
                    fontSize: "11px",
                    fontWeight: "400",
                  }}
                >
                  {data && data.description.toString().length > 90
                    ? data.description.toString().substr(0, 46) + "..."
                    : data.description}
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <h6
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#B1B1B1",
                }}
              >
                <img
                  src={window.origin + "/WebSide/assets/images/write.png"}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginLeft: "5px",
                  }}
                  alt="همه ملاقات"
                />
                {data && data.authtor.fullname}
              </h6>
              <h6
                style={{
                  fontSize: "12px",
                  color: "#B1B1B1",
                  fontWeight: "400",
                }}
              >
                <img
                  src={window.origin + "/WebSide/assets/images/cat.png"}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginLeft: "5px",
                  }}
                  alt={data && data.blog_category && data.blog_category.name}
                />
                {data && data.blog_category && data.blog_category.name}
              </h6>
            </div>
          </div>
        </div>
      </Link>
    </Fragment>
  );
}

export default RandomBlogCardSidebar;
